import { useState } from 'preact/hooks';
import { PAGES } from '../../content/pages';
import { t } from '../../engine/i18n';
import type { GameState, PageId } from '../../engine/state';
import { Card } from '../components';

export function NotebookTab({ state }: { state: GameState }) {
  const [selected, setSelected] = useState<PageId | null>(null);
  if (state.pages.length === 0) return <p class="muted">{t('notebook.empty')}</p>;
  const current = selected && state.pages.includes(selected) ? selected : state.pages[state.pages.length - 1];

  return (
    <div class="notebook">
      <nav class="notebook-index" aria-label={t('notebook.title')}>
        <p class="muted">{t('notebook.count', { count: state.pages.length })}</p>
        {state.pages.map((page) => (
          <button
            key={page}
            class={page === current ? 'index-item active' : 'index-item'}
            onClick={() => setSelected(page)}
          >
            {t(PAGES[page].title)}
          </button>
        ))}
      </nav>
      <Card className="page-card">
        <p class="eyebrow">{t('notebook.title')}</p>
        <h2 class="card-title">{t(PAGES[current].title)}</h2>
        <p class="handwritten">{t(PAGES[current].text)}</p>
      </Card>
    </div>
  );
}
